
    var riot = require('riot')
    //src: starling/src/tags/modal-template.html
riot.tag2('modal-template',
  '<a class="modal-template_anchor" href="{opts.url}" onclick="{clickHandler}" target="{!opts.inline && \'_blank\'}" data-track="Template-Modal" data-track-action="Map-Template-New-Map" data-track-label="Templates"> <div class="modal-template_thumbnail"> <img class="modal-template_thumbnail_image responsive" riot-src="{opts.thumbnail || \'/share-image.png\'}" alt="{opts.title}"> </div> <h3 class="modal-template_title">{opts.title}</h3> <p if="{opts.description}" class="modal-template_description">{opts.description}</p> </a>',
  '',
  'class="modal-template"', function(opts) {
'use strict';

var _this = this;

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _opts = this.opts,
    canvas = _opts.canvas,
    url = _opts.url;
var store = canvas.store;

this.clickHandler = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
    var parent, template, topNodeIds, sortedIds, sortByDepth, sortedNodes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sortByDepth = function sortByDepth(parentNodeIds) {
              var childrenIds = template.map_data.nodes.filter(function (n) {
                return parentNodeIds.includes(n.parentId);
              }).map(function (n) {
                return n.id;
              });
              if (childrenIds.length > 0) {
                sortedIds = sortedIds.concat(childrenIds);
                sortByDepth(childrenIds);
              }
            };

            parent = _this.parent;

            if (_this.opts.inline) {
              _context.next = 5;
              break;
            }

            parent.dismiss();
            return _context.abrupt('return');

          case 5:

            // only inline load a template once, during the page load
            parent.makeOpenNew();

            if (!(window.pageSettings.isTryNow && url === '')) {
              _context.next = 9;
              break;
            }

            parent.dismiss();
            return _context.abrupt('return');

          case 9:
            ;

            e.preventDefault();
            e.stopPropagation();

            parent.startLoading();
            _context.next = 15;
            return $.ajax(url);

          case 15:
            template = _context.sent;

            parent.dismiss();

            topNodeIds = template.map_data.nodes.filter(function (n) {
              return !n.parentId;
            }).map(function (n) {
              return n.id;
            });
            sortedIds = topNodeIds.slice();

            sortByDepth(topNodeIds);
            sortedNodes = sortedIds.map(function (id) {
              return template.map_data.nodes.find(function (n) {
                return id === n.id;
              });
            });

            template.map_data.nodes = sortedNodes;

            _copyPaste2.default.pasteData({ canvas: canvas, data: template.map_data });
            canvas.update();
            canvas.fitMapContents();

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-template')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-template.html
// module id = 752
// module chunks = 0